<template>
  <div class="app-checkout-shoppingcart-mobile-wrapper">
    <div class="drawerPlaceholder" id="drawerPlaceholder">
      <b-row class="promo-container">
        <b-col class="icons">
          <div class="shopping-venture"></div>
          <div class="arrow-down"></div>
        </b-col>
        <b-col class="priceCol">
          <b-row class="priceRow">
            <span class="pPrice">
               {{ priceWithoutEuro(getSimCardOption.productPrice) }} <span class="pSign">€</span>
            </span>
            <span class="tariffPeriod"><slot name="tariffPeriod">einm.</slot></span>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div id="drawer" class="drawer">
      <div class="close-icon" id="closeButton"></div>
      <div class="innerContent">
        <div  class="content-wrap">
          <h3><slot name="headline">Deine Bestellübersicht</slot></h3>
          <div class="content-row">
            <div class="content-one promo-container">
              <b-row>
                <b-col>
                  <div v-if="isEsim">
                    <div class="pTtop"><slot name="lableESim">eSIM</slot></div>
                    <div class="pSsub"><slot name="lableESimSubline">(einmalig)</slot></div>
                  </div>
                  <div v-else>
                    <div class="pTtop"><slot name="lableSim">Triple SIM-Karte</slot></div>
                    <div class="pSsub"><slot name="lableSimSubline">(einmalig)</slot></div>
                  </div>
                </b-col>
                <b-col>
                  <span class="pPrice">
                     {{ priceWithoutEuro(getSimCardOption.productPrice) }} <span class="pSign">€</span>
                  </span>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col>
                  <div>
                    <div class="pTtop">Versandkosten</div>
                    <div class="pSsub">(einmalig)</div>
                  </div>
                </b-col>
                <b-col class="addPrice">
                  {{ formattedShipping }} €
                </b-col>
              </b-row>
              <hr>
            </div>
            <b-row class="cDiv" v-if="isFreeEsim">
              <b-col>
                <ul class="check-list">
                  <li class="with-paw">
                    <slot name="listFreeEsim">Die ersten 30 Tage: <strong>Kostenlos</strong> zur eSIM wechseln</slot>
                  </li>
                </ul>
              </b-col>
            </b-row>
          </div>
          <div class="lDiv">
            <b-col class="pInfo"><slot name="txtMwStInfo">Alle Preise inkl. MwSt.</slot></b-col>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" id="overlay"></div>
  </div>
</template>

<script>
import { BCol } from 'bootstrap-vue'
import shoppingCartMobile from '@/mixins/shoppingCartMobile'
import priceWithoutEuro from '@/mixins/formatters/price'
import { mapGetters } from 'vuex'

export default {
  name: 'SimShoppingCartMobileWrapper',
  data () {
    return {}
  },
  mixins: [
    priceWithoutEuro,
    shoppingCartMobile()
  ],
  components: {
    BCol
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'setSubstituteSimCardOptions',
      'getSimCardOption',
      'isFreeEsim',
      'isEsim'
    ]),
    formattedShipping: function () {
      // Ausnahme, da die 0 keine Nachkommastellen haben soll
      if (this.getSimCardOption.shippingCosts !== 0) {
        return this.priceWithoutEuro(this.getSimCardOption.shippingCosts)
      } else {
        return 0
      }
    }
  },
  methods: {
    clickDrawerPlaceholder (e) {
      this.openDrawer()
      this.shoppingCartWasOpen = true
    },
    clickCloseButton (e) {
      this.closeDrawer()
      this.shoppingCartWasOpen = false
    }
  },
  mounted () {
    document.getElementById('drawerPlaceholder').addEventListener('click', this.clickDrawerPlaceholder, false)
    document.getElementById('closeButton').addEventListener('click', this.clickCloseButton, false)
  }
}
</script>
